// @flow
import {SUBSEQUENT_FLEX_DATES_OPTIONS_TOGGLE} from '../actions/flexDates';
import type {SubsequentFlexDatesOptionsToogleAction} from '../actions/flexDates';

export type State = {
    isSubsequentFlexDatesView: boolean
};

const initialState = {
    isSubsequentFlexDatesView: false
};

export default function reducer(
    state: State = initialState,
    action: SubsequentFlexDatesOptionsToogleAction
): State {
    if (action.type === SUBSEQUENT_FLEX_DATES_OPTIONS_TOGGLE) {
        return {
            ...state,
            isSubsequentFlexDatesView: action.payload.isSubsequentFlexDatesView
        };
    }
    return state;
}
